var parent = require('../../es/object/entries');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/entries.js
// module id = 1126
// module chunks = 0